import { t } from 'app/i18l'

export function usePolicies() {
  return {
    privacy: {
      title: t('privacyPolicy'),
      url: 'https://nextmanager.us/privacy.html',
    },
    termsOfUse: {
      title: t('termsOfUse'),
      url: 'https://nextmanager.us/tos.html',
    },
  }
}
